import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import UmbrellaTable from "../../components/UmbrellaManagement/UmbrellaTable";
import UmbrellaTableV2 from "../../components/UmbrellaManagement/UmbrellaTableV2";





const UmbrellaManagementPage = () => {
    return (
        <>
        
            <MasterLayout>

                <Breadcrumb title="Umbrella Management" />
                {/* <UmbrellaTable/> */}
                <UmbrellaTableV2/>


   
           



            </MasterLayout>
        </>
    );
};

export default UmbrellaManagementPage;
